import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PromotionEnumType } from "../enums/promotionEnum";
interface Props {
    promotionType: PromotionEnumType;
}
const PromotionText = ({ promotionType }: Props) => {
    const { t } = useTranslation('global');
    const getPromotionText = (type: PromotionEnumType): string => {
        switch (type) {
            case PromotionEnumType.buy_x_get_x:
                return t('promotion_page.buy_x_get_x');
            case PromotionEnumType.buy_x_get_ds:
                return t('promotion_page.buy_x_get_ds');
            case PromotionEnumType.buy_x_get_y:
                return t('promotion_page.buy_x_get_y');
            case PromotionEnumType.buy_x_u_get_spp:
                return t('promotion_page.buy_x_u_get_spp');
            case PromotionEnumType.buy_x_set_u_get_cbd:
                return t('promotion_page.buy_x_set_u_get_cbd');
            case PromotionEnumType.buy_x_set_a_get_cbp:
                return t('promotion_page.buy_x_set_a_get_cbp');
            case PromotionEnumType.buy_x_set_a_get_rd:
                return t('promotion_page.buy_x_set_a_get_rd');
            case PromotionEnumType.buy_x_set_a_get_cst_by_price:
                return t('promotion_page.buy_x_set_a_get_cst_by_price');
            case PromotionEnumType.buy_x_set_u_get_cst_by_unit:
                return t('promotion_page.buy_x_set_u_get_cst_by_unit');
            default:
                return '';
        }
    };
    return (
        <Typography color="red" fontSize="13px">
            {getPromotionText(promotionType)}
        </Typography>
    );
};
export default PromotionText;